import { MEXICO_PROVINCES } from "_common/regions/regions";
import { campecheAttraction } from "_common/attractions/region/campecheAttraction";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";
import { guanajuatoAttraction } from "_common/attractions/region/guanajuatoAttraction";
import { jaliscoAttraction } from "_common/attractions/region/jaliscoAttraction";
import { bcsAttraction } from "_common/attractions/region/bcsAttraction";
import { nayaritAttraction } from "_common/attractions/region/nayaritAttraction";
import { oaxacaAttraction } from "_common/attractions/region/oaxacaAttraction";
import { quintanarooAttraction } from "_common/attractions/region/quintanarooAttraction";
import { pueblaAttraction } from "_common/attractions/region/pueblaAttraction";
import { yucatanAttraction } from "_common/attractions/region/yucatanAttraction";

export type TAttraction = {
    name: string;
    region: MEXICO_PROVINCES;
    coordinates: {
        lat: number;
        lng: number;
    };
    type: ATTRACTION_TYPE;
};

export const MEXICO_ATTRACTIONS: TAttraction[] = [
    ...bcsAttraction,
    ...campecheAttraction,
    ...guanajuatoAttraction,
    ...jaliscoAttraction,
    ...nayaritAttraction,
    ...oaxacaAttraction,
    ...quintanarooAttraction,
    ...pueblaAttraction,
    ...yucatanAttraction,
];
